import React, {FC, ReactNode} from 'react';

import {KeyboardActionsEnum} from '../../../../libs/shared/helpers/src/browser/keyboardHelpers';
import {TooltipShortcutFormatter} from '../../../../libs/shared/ui/src/components/tooltips/tooltipShortcutFormatter';

/*
 * Props.
 */

interface TooltipLabelWithShortcutProps {
  label: ReactNode;
  keyboardAction?: KeyboardActionsEnum;
}

/*
 * Component.
 */

export const TooltipLabelWithShortcut: FC<TooltipLabelWithShortcutProps> = (props) => (
  <>
    {props.label} {props.keyboardAction ? <TooltipShortcutFormatter action={props.keyboardAction} /> : null}
  </>
);
